export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-k12-banner-educator@2x-419e1e4caae6ab84ec867bb94420c5df.png";